<script setup lang="ts">
	import { useBasePrinter } from './BasePrinter.js';
	import {ref,onMounted} from 'vue';
	

	const props = defineProps({
		value: String,
		style: String,
		styleClass: String,
		//styleId: String,
		link: String,
		linkTarget: String,
		//tooltip: String,
		sortStyle: Object,
		rowValue: String
	});
	
	const theLink = ref(null);
	const theHtml = ref(null);
	const {hasLink, tdStyle} = useBasePrinter(props);
	
	onMounted(() => {
		if (theLink.value) {
			crm.initPreviewFor(theLink.value);
		}
		else if (theHtml.value) {
			crm.initPreview(theHtml.value);
		}
	});
		
</script>
<template>
<td :class="styleClass" :style="[sortStyle, tdStyle]">
	<a v-if="hasLink" :href="link" v-html="value" :target="linkTarget" ref="theLink"></a>
	<span v-else v-html="value" ref="theHtml"></span>
</td>
</template>

